import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { useState as d } from "react";
import { useTranslation as u, Modal as I, Loader as M, toast as h } from "@systemeio/ui";
import { twMerge as x } from "tailwind-merge";
const e = "xendit-3ds-frame", E = (a) => {
  const [c, t] = d(!1), [r, s] = d(!1), { t: n } = u();
  return { threeDsModal: /* @__PURE__ */ f(
    I,
    {
      opened: c,
      onClose: () => {
        t(!1), a();
      },
      title: n("public_pages_purchase.payment.xendit.3ds"),
      children: [
        r && /* @__PURE__ */ i(M, { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }),
        /* @__PURE__ */ i(
          "iframe",
          {
            className: x("h-[650px] w-full", r && "invisible"),
            id: e,
            title: e,
            name: e
          }
        )
      ]
    }
  ), openLinkInIframe: (m) => {
    t(!0);
    const p = 10;
    let o = 0;
    s(!0);
    const l = setInterval(() => {
      o++, document.getElementById(e) ? (clearInterval(l), s(!1), window.open(m, e)) : o >= p && (clearInterval(l), h.error(n("public_pages_purchase.error")), t(!1), s(!1), a());
    }, 500);
  }, closeThreeDsModal: () => {
    t(!1);
  } };
};
export {
  E as useXenditThreeDs
};
